import { FC } from "react";
import SmartSearchAndActionsLayout from "../../../components/Layouts/smart-search-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import {
  GetCurrentPulltabGamesParams,
  getCurrentPulltabGames,
} from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";
import {ValidationEnum} from "../../../enums/validationEnum";

const ReportPulltabsCurrentPulltab: FC = () => {
  return (
    <SmartSearchAndActionsLayout
      searchBy={[
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_PDF,
        ActionButtonEnum.SAVE_CSV,
      ]}
      validations={[
          ValidationEnum.VALIDATE_SMART_SEARCH,
          ValidationEnum.VALIDATE_SEARCH,
      ]}
      validOnEmpty={false}
      onRefresh={(output, params) => {
        const getCurrentPullTabGamesParams: GetCurrentPulltabGamesParams = {
            name:"Current Pull-Tab Games",
            output,
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getCurrentPullTabGamesParams[id] = params.id;
        }

        return getCurrentPulltabGames(getCurrentPullTabGamesParams);
      }}
    />
  );
};

export default ReportPulltabsCurrentPulltab;
